import {saveNSAData} from './constants';

export const saveNewServiceAgreementData = (data) => (dispatch) => {
    dispatch({
        type: saveNSAData.NEW_SERVICE_AGREEMENT_DATA_SAVE_SUCCESS,
        data: data,
      });
};
